import { SFC } from 'react';
import { connect } from 'react-redux';
import { getMediaQueryBreakpoints } from 'ha/modules/UI/selectors';

export interface MediaQueryBreakpoints {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
}

interface Props {
  mediaQueryBreakpoints: MediaQueryBreakpoints;
  children: (
    mediaQueryBreakpoints: MediaQueryBreakpoints,
  ) => JSX.Element | null;
}

const MediaQuery: SFC<Props> = ({ children, mediaQueryBreakpoints }) =>
  children(mediaQueryBreakpoints);

export default connect(state => ({
  mediaQueryBreakpoints: getMediaQueryBreakpoints(state),
}))(MediaQuery);
